import { render, staticRenderFns } from "./StatisticsTrendYearChart.vue?vue&type=template&id=3681d57a&scoped=true"
import script from "./StatisticsTrendYearChart.vue?vue&type=script&lang=js"
export * from "./StatisticsTrendYearChart.vue?vue&type=script&lang=js"
import style0 from "./StatisticsTrendYearChart.vue?vue&type=style&index=0&id=3681d57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3681d57a",
  null
  
)

export default component.exports